import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import ListingPresentationIntro from './ListingPresentationIntro/listing.presentation.intro.vue';
import ListingPresentationList from '../../shared/ListingPresentationList/listing.presentation.list.vue';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
   components: {
      Header,
      NavSide,
      SpinLoader,
      ListingPresentationIntro,
      ListingPresentationList,
      ASpaceInBetweenAnother,
   },
})
export default class ListingPresentationPage extends Vue {
   public title: string = 'ListingPresentationPage';
   public isLoading: boolean = false;

   public created() {
      this.$store.commit('selectSection', '10');
   }

   public onNewPresentation() {
      this.$router.push('/listing-presentation/stage');
  }
}
